import { Role } from './../_models/role.model';
import { currentUser } from './../_selectors/auth.selectors';
import { AppState } from './../../reducers/index';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

@Injectable()
export class RolesGuard implements CanActivate {
  constructor(private store: Store<AppState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const roles = route.data.roles;

    if (!roles) {
      return true;
    }

    return this.store.pipe(
      select(currentUser),
      map((user) => {
        if (user) {
          if (user.roles && user.roles.length) {
            return user.roles.some((role: Role) => roles.includes(role.name));
          }

          return true;
        }
      }),
    );
  }
}
